<!--监测数据 monitor-->
<template>
  <div class="historyCurve">
    <div class="con">
      <div class="tree-left">
        <span class="tree-left-tit" @click="base">监测点及局放设备列表</span>
        <el-tree :data="virtualDeviceList" :props="defaultProps" @node-click="checkFun"></el-tree>
      </div>
      <div class="right-table">
        <div class="mingxi">
          <div class="tit">局放信息明细</div>
          <el-form ref="form" :model="form" label-width="150px" :inline="true">
            <el-form-item label="局部放电类型:">
              <el-select v-model="form.deviceType" class="inp" placeholder="请选择" @change="bbb" size="mini">
                <el-option v-for="item in optionsed" :key="item.id" :label="item.itemText" :value="item.itemValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="故障预警等级:">
              <el-input class="inp" v-model="form.malfunctionLv" size="mini" readonly></el-input>
            </el-form-item>
            <el-form-item label="采样均值:">
              <el-input class="inp" v-model="form.samplingAverage" size="mini" readonly></el-input>
            </el-form-item>
            <el-form-item label="采样峰值:">
              <el-input class="inp" v-model="form.samplingTop" size="mini" readonly></el-input>
            </el-form-item>
            <el-form-item label="峰值相位:">
              <el-input class="inp" v-model="form.topPhase" size="mini" readonly></el-input>
            </el-form-item>
            <el-form-item label="脉冲计数:">
              <el-input class="inp" v-model="form.pulseNum" size="mini" readonly></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="prps" style="overflow: hidden;">
          <div class="tit">PRPS图谱</div>
          <div :style="{height:(heights+150)+'px'}" id="proportion"></div>
        </div>

        <div class="prps">
          <div class="tit">PRPD图谱</div>
          <vchart :style="{height:(heights-152)+'px'}" class="vcharted" ref='vchart'></vchart>
        </div>


        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<script type="text/javascript">
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import elUnitTree from '@/components/module/newTree/elDeviceTree.vue'
  import elUnitTree2 from '@/components/module/newTree/elUnitTree2.vue';
  import * as echarts from 'echarts';
  import "echarts-gl"
  import request from "@/api/http.js";

  export default {
    components: {
      vchart,
      elUnitTree,
      elUnitTree2,
      downloadTable
    },
    props: [],
    data () {
      return {
        listData: [],
        listDataIn: '',
        indexed: 0,//0-50
        defaultProps: {
          children: 'deviceLists',
          label: 'name'
        },
        optionsed: [],
        options: {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '5%',
            top: '9%',
            right: '4%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: Array.from({length: 64},(_,i) => i+1),
            axisLabel: {
              showMaxLabel: true,
              interval: 0,

            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [],
              smooth: false,
              symbol: 'none',
              showSymbol: false,
              type: 'line'
            }
          ]
        },
        form: {},
        dataList: [],
        flag: false,
        deviceNos: [],
        loading: false,
        heights: Math.round((document.getElementById('app').clientHeight)/3),

        virtualDeviceList: [],
        timeOut: '',
        nowDevice: {}
      }
    },
    mounted () {
      this.base();
      this.getList2()
      this.getList();
      this.listDataIn=setInterval(() => {
        this.getList();
      },1000);
    },


    beforeDestroy () {
      // 在组件销毁之后取消定时器
      clearInterval(this.listDataIn);
    },
    methods: {
      bbb (v) {
        console.log(v);
        var params={
          id: this.nowDevice.id,
          type: v,
        }
        // 获取局放设备的所有设备类型
        request({url: "/partial/configurationType",method: "post",params}).then(res => {
          if(res.code==200) {
            this.getList();
          }
        })
      },
      base () {
        // 获取局放设备树形图
        var params={unitId: '63c8d075643f4a04bda34d97d8fce42a'}
        this.virtualDeviceList=[
          {
            "id": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
            "pointName": "前山变电站1#开关柜",
            "deviceLists": [
              {
                "id": "16d8692fd76646a2a970ad079748889d",
                "name": "2#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -3
              },
              {
                "id": "22b2c3f18f004e559f7ad6b89030a27a",
                "name": "8#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -9
              },
              {
                "id": "48fc10c035ed4149b630eefcae6501b5",
                "name": "5#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -6
              },
              {
                "id": "83ec36f476b144fa8189d2f5dd1e79cf",
                "name": "3#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -4
              },
              {
                "id": "ab4d50a7b340410dbdca7a5d1c397afb",
                "name": "7#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -8
              },
              {
                "id": "d31b20134a704c3a96aae853f61322e7",
                "name": "6#高频电缆",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -7
              },
              {
                "id": "f3ca093ff7c84987bf8d3476a4a2a5d2",
                "name": "4#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -5
              },
              {
                "id": "f7cf3f5a6419479ab9fa2ad79edefe19",
                "name": "1#高频局放",
                "parentid": "6a82a9d6fdda46b9b8ebf635dfbe96b1",
                "deviceNo": -2
              }
            ]
          }
        ];
        this.virtualDeviceList.map(a => {
          a.name=a.pointName;
        })


        // 获取局放设备的所有设备类型
        this.optionsed=[
          {
            "createTime": null,
            "pkid": "fd6529d59bc545d587b61f0cc9aa1d8a",
            "itemText": "特高频",
            "itemValue": "0",
            "editable": 1,
            "sort": 21.0,
            "enumCode": "JF_deviceCategory",
            "id": "fd6529d59bc545d587b61f0cc9aa1d8a",
            "entityName": "AppEnumItem"
          },
          {
            "createTime": null,
            "pkid": "03ec89419f074375a869f4d368eabcd5",
            "itemText": "超声波",
            "itemValue": "1",
            "editable": 1,
            "sort": 22.0,
            "enumCode": "JF_deviceCategory",
            "id": "03ec89419f074375a869f4d368eabcd5",
            "entityName": "AppEnumItem"
          },
          {
            "createTime": null,
            "pkid": "b3d65a06f54a4f39a94dd8cc16494ce3",
            "itemText": "地电波",
            "itemValue": "2",
            "editable": 1,
            "sort": 23.0,
            "enumCode": "JF_deviceCategory",
            "id": "b3d65a06f54a4f39a94dd8cc16494ce3",
            "entityName": "AppEnumItem"
          },
          {
            "createTime": null,
            "pkid": "e4f23134bacd442abe3ed0e1eff08d28",
            "itemText": "脉冲电流",
            "itemValue": "3",
            "editable": 1,
            "sort": 24.0,
            "enumCode": "JF_deviceCategory",
            "id": "e4f23134bacd442abe3ed0e1eff08d28",
            "entityName": "AppEnumItem"
          }
        ];
      },
      makeTree (arr) {
        var temp=[];
        for(var i=0;i<arr.length;i++) {
          //如果某个元素的parentId和传入的pid相等，作为pid对应id对象的children集合中的数据
          arr[i].label=arr[i].pointName||rr[i].name;
          if(arr,arr[i].deviceLists) {
            arr[i].children=this.makeTree(arr,arr[i].deviceLists);
          }

          temp.push(arr[i]);
          //再递归的生成关系树
        }
        return temp;
      },
      getList () {
        var params={deviceNo: this.nowDevice.deviceNo}
        this.form={
          "malfunctionLv": "0",
          "samplingAverage": "-65",
          "samplingTop": "-79",
          "topPhase": "202.5",
          "pulseNum": "0",
          "atlas": "0 3 6 9 12 15 18 21 24 23 26 29 32 35 38 37 40 43 46 49 52 54 57 60 61 62 63 64 64 64 63 64 64 63 62 61 60 58 56 55 50 45 40 35 30 25 20 15 10 2 16 24 34 32 30 28 26 30 34 38 40 40 30 20 9",
          "deviceType": "地电波"
        };
        var d=this.form.atlas.split(' ');
        d.map((v,i) => {
          if(v=='') {
            d.splice(i,1); // 从 index 处开始删除一个元素
          }
        })
        this.options.series[0].data=d;
        if(this.$refs.vchart) {
          this.$refs.vchart.setData(this.options,true);
        }

        this.getList2();
      },
      aaa (v) {


        var listData=[]
        v.map((a,i) => {
          a.map((b,ii) => {
            listData.unshift([i,ii,b])
          })
        })
        this.dialogVisible2=true;

        // prettier-ignore
        var hours=Array.from({length: 65},(_,i) => i);

        var days=Array.from({length: 50},(_,i) => i);



        var option={
          tooltip: {},
          visualMap: {
            max: 64,
            inRange: {
              color: [
                '#7db645',
                '#3f897a',
                '#4c4f8e',
                '#867b90',
                '#f0e03f',
                '#e23e35',
                '#c57198'
              ]
            }
          },
          xAxis3D: {
            name: '相位(°)',
            type: 'category',
            data: hours,
            axisLabel: {
              // 设置刻度为每5个递进
              showMaxLabel: true,
              interval: 16,
              formatter: (value,index) => {
                // 1小时=3600秒
                var d={
                  '8': 45,
                  '16': 90,
                  '24': 135,
                  '32': 180,
                  '40': 225,
                  '48': 270,
                  '56': 315,
                  '64': 360,
                }
                return d[value];
              },
            }
          },
          yAxis3D: {
            name: '周期',
            type: 'category',
            data: days,
            axisLabel: {
              showMaxLabel: true,
              // 设置刻度为每5个递进
              interval: 4
            }
          },
          zAxis3D: {
            name: '相对幅值(V)',
            type: 'value'
          },
          grid3D: {
            boxWidth: 300,
            boxDepth: 200,
            viewControl: {
              projection: 'perspective', // 先设置为这个perspective
              distance: 320,
              // 设置视角的上下旋转角度，取值范围为 -90 ~ 90
              beta: 47,
              // 设置视角的左右旋转角度，取值范围为 -180 ~ 180
              alpha: 5
            },
          },
          series: [
            {
              type: 'bar3D',
              data: listData.map(function(item) {
                return {
                  value: [item[1],item[0],item[2]]
                };
              }),
              shading: 'color',
              label: {
                show: false,
                fontSize: 16,
                borderWidth: 1
              },
              itemStyle: {
                opacity: 0.4
              },
              emphasis: {
                label: {
                  fontSize: 20,
                  color: '#900'
                },
                itemStyle: {
                  color: '#900'
                }
              }
            }
          ]
        };

        var proportion=echarts.init(document.getElementById("proportion"));


        if(this.indexed>0) {
          proportion.setOption({
            series: option.series
          })
        } else {
          this.indexed=1;
          proportion.setOption(option,true);
        }
      },

      getList2 () {
        if(this.indexed>50) {//最大宽50
          this.indexed=0;
        }
        var a=this.form.atlas;
        // prettier-ignore
        var hours=Array.from({length: 65},(_,i) => i);

        var days=Array.from({length: 50},(_,i) => i);
        if(this.form.atlas) {
          var d=this.form.atlas.split(' ');//数据
          console.log(d.length,'d.length');
          if(d.length==3200) {
            var result=[];
            for(var i=0;i<d.length;i+=64) {
              result.push(d.slice(i,i+64));
            }
            this.aaa(result)

            return
          }
          d.map((v,i) => {
            if(v=='') {
              d.splice(i,1); // 从 index 处开始删除一个元素
            }
          });

          // prettier-ignore
          // var data=[[50,64,0]]; [0,1,5],[0,64,5]
          this.listData.map(v => {
            v[0]=v[0]+1;
          })
          if(this.listData.length>3200) {
            this.listData.splice(3200,this.listData.length-3200);
          };
          d.map((v,i) => {
            this.listData.unshift([0,i,v])
          });


        }


        var option={
          tooltip: {},
          visualMap: {
            max: 64,
            inRange: {
              color: [
                '#7db645',
                '#3f897a',
                '#4c4f8e',
                '#867b90',
                '#f0e03f',
                '#e23e35',
                '#c57198'
              ]
            }
          },
          xAxis3D: {
            name: '相位(°)',
            type: 'category',
            data: hours,
            axisLabel: {
              // 设置刻度为每5个递进
              showMaxLabel: true,
              interval: 7,
              formatter: (value,index) => {
                // 1小时=3600秒
                var d={
                  '8': 45,
                  '16': 90,
                  '24': 135,
                  '32': 180,
                  '40': 225,
                  '48': 270,
                  '56': 315,
                  '64': 360,
                }
                return d[value];
              },
            }
          },
          yAxis3D: {
            name: '周期',
            type: 'category',
            data: days,
            axisLabel: {
              showMaxLabel: true,
              // 设置刻度为每5个递进
              interval: 4
            }
          },
          zAxis3D: {
            name: '相对幅值(V)',
            type: 'value'
          },
          grid3D: {
            boxWidth: 300,
            boxDepth: 200,
            viewControl: {
              projection: 'perspective', // 先设置为这个perspective
              distance: 320,
              // 设置视角的上下旋转角度，取值范围为 -90 ~ 90
              beta: 47,
              // 设置视角的左右旋转角度，取值范围为 -180 ~ 180
              alpha: 5
            },
          },
          series: [
            {
              type: 'bar3D',
              data: this.listData.map(function(item) {
                return {
                  value: [item[1],item[0],item[2]]
                };
              }),
              shading: 'color',
              label: {
                show: false,
                fontSize: 16,
                borderWidth: 1
              },
              itemStyle: {
                opacity: 0.4
              },
              emphasis: {
                label: {
                  fontSize: 20,
                  color: '#900'
                },
                itemStyle: {
                  color: '#900'
                }
              }
            }
          ]
        };

        var proportion=echarts.init(document.getElementById("proportion"));

        if(this.indexed>0) {
          proportion.setOption({
            series: option.series
          })
        } else {
          proportion.setOption(option,true);
        }

        this.indexed++
      },
      checkFun (val) {

        this.nowDevice=val

        this.listData=[];
        this.indexed=0;
        this.form.atlas='';

        this.options.series=[
          {
            data: [],
            type: 'line'
          }
        ];
        this.$refs.vchart.setData(this.options,true);
        this.getList2();
        this.getList();

      },

    }
  }
</script>

<style scoped lang="scss">
  .inp {
    width: 184px
  }

  #proportion {
    transform: translateY(-50px);
  }

  .vcharted {
    width: 100%;
  }

  .prps {
    border: 1px solid #000;
  }

  .prps .tit {
    background: #abcef5;
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    text-align: center;
  }

  #proportion {
    height: 500px;
    width: 100%;
  }

  .mingxi {
    border: 1px solid #000;
  }

  .mingxi .tit {
    background: #abcef5;
    width: 100%;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    text-align: center;
  }

  .el-form .el-form-item {
    margin-bottom: 0;
  }

  .right-table {
    position: relative;

    /deep/.el-scrollbar {
      overflow: inherit;
    }

    /deep/.el-scrollbar__wrap {
      overflow-y: hidden;
    }

    .search-input-btn {
      overflow: inherit;
    }

    .unitMenu {
      overflow: hidden;

      /deep/.el-scrollbar__wrap {
        overflow-y: inherit;
      }
    }
  }

  .historyCurve {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      /deep/.el-date-editor .el-range-separator {
        line-height: 26px;
      }

      /deep/.el-date-editor .el-range__icon {
        line-height: 23px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        padding-top: 25px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;
        position: relative;

        .tree-left-tit {
          position: absolute;
          top: 0;
          background: #abcef5;
          left: 0;
          width: 100%;
          height: 22px;
          line-height: 22px;
          font-size: 14px;
          text-align: center;
        }

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
      }
    }
  }
</style>
<style scoped>
  .block {
    width: 20px;
    height: 20px;
    background-color: #d9d9d9;
    cursor: pointer;
    margin-left: 10px;
  }

  .unitMenu {
    /* max-width: 4rem; */
    height: 4rem;
    top: 7px;
    margin-left: 78px;
    padding-top: 32px;
    position: absolute;
    z-index: 99999;
  }

  .unitMenu .elUnitTreeBody {
    width: 2.4rem;
  }

  .unitMenu .readDeviceTreeBody {
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 10px 10px;
  }

  .cropper-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ul {
    padding: 0 15px;
  }

  .ul .li {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
  }

  .ul .li .r {
    color: #378cd4;
    cursor: pointer;
  }

  .btns {
    width: 300px;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #d7d7d7;
    margin: 0 15px;
  }

  .color-span {
    display: inline-block;
    width: 15px;
    height: 15px;
    transform: translate(5px, 2px);
    color: #1a1a1a;
  }

  .user-arrow {
    width: 20px;
    height: 20px;
  }

  .tongyi-img {
    width: 20px;
    height: 20px;
  }

  .arrow-active {
    transform: rotateZ(180deg);
  }

  .topMenu {
    height: .5rem;
    overflow-y: hidden;
    /* overflow: hidden; */
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .nowUnit-name {
    margin-left: 0.2rem;
    width: 2.14rem;
    height: 30px;
    border: 1px solid #ccc;
    text-align: left;
    line-height: 30px;
    padding: 0px 12px;
    /* margin-left: 5px; */
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .nowUnit-name span {
    color: #666666;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nowUnit-name img {
    width: 18px;
    height: 18px;
    transition: 0.5s;
  }

  .nowUnit-active {
    border: 1px solid #409eff;
  }

  .nowUnit-active1 {
    border: 1px solid #fff;
  }

  .nowUnit-active img {
    transform: rotateZ(180deg);
  }

  .nowUnit-active1 img {
    transform: rotateZ(180deg);
  }

  /* 需要转化 */
  .tags-view-container {
    height: 34px;
    width: calc(100% - 2rem);
    position: absolute;
    top: 48px;
    left: 200px;
    /* margin-left: 200px; */
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    -webkit-box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
    z-index: 999;

  }

  .tags-view-container .content {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
  }

  .sidebar-logo {
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }

  .sidebar-title {
    display: inline-block;
    margin: 0;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
    vertical-align: middle;
    margin-left: 10px;
  }

  /* 需要转化结束 */


  .userName {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #1a1a1a;
  }

  .webTitle {
    height: .5rem;
    width: auto;
    text-align: center;
    line-height: .5rem;
    font-size: 21px;
    font-weight: bold;
    width: 500px;
    color: #212529
  }

  .leftPart {
    /* width: calc(50% - 150px); */
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* background-color: #2b2f3a; */
    /* background-color: #fff; */
  }

  .leftPart-logo {
    width: 2rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 9px;
    /* background-color: #304156; */
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.35s;
    flex-shrink: 0;
  }

  .leftPart-logo-active {
    width: 0.8rem;
  }

  .logo {
    max-width: 185px;
    max-height: 40px;
  }

  .rightPart {
    /* width: calc(50% - 50px); */
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .leftPartImg {
    height: 48px;
    display: flex;
    align-items: center;
    width: 50px;
    /*border-bottom: 2px solid #116af0;*/
  }

  .rightPart .user {
    /* width: auto; */
    margin-left: 10px;
    max-width: 2rem;
    min-width: .2rem;
    /* height: .2rem; */
  }

  .rightPart .userSelect {
    cursor: pointer;
    width: auto;
    max-width: 2rem;
    min-width: .08rem;
    height: .06rem;
    margin-right: 20px;
    margin-top: 11px;
  }

  .unitSelect {
    /* min-width: 1rem; */
    height: 100%;
    /*border-bottom: 2px solid #cce1ff;*/
    height: 48px;
  }

  .unitSelect>div>input {
    width: 150px;
    background: rgba(0, 0, 0, 0);
    border: 0;
    /* border-left: 1px #49649c solid; */
    border: 1px solid #dcdfe6;
    border-radius: 0;
    padding: 5px 10px;
    height: 20px;
    line-height: 20px;
    outline: none;
    margin: 0 10px;
    color: white;
  }

  .userMenu {
    padding-top: .5rem;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
  }



  .area-tree {
    position: absolute;
    max-width: 2.5rem;
    height: 4rem;
    /* margin-left: 4rem; */
    /* top: 0; */
    top: 0;
    /* right: 0px; */
    margin-left: 19px;
    padding-top: .5rem;
    z-index: 99999;
    width: 77%;
  }

  .area-tree .elUnitTreeBody {
    width: 2.4rem;
  }

  .area-tree .readDeviceTreeBody {
    border-width: 1px;
    border-style: solid;
    border-radius: 0 0 10px 10px;
  }

  .menuItem {
    height: 33px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .05rem .1rem;
    width: auto;
    cursor: pointer;
    background: white;
    border-left: solid .01rem #BABEC2;
    border-right: solid .01rem #BABEC2;
    border-bottom: solid .01rem #BABEC2;
  }

  .menuItem:last-child {
    border-radius: 0 0 .05rem .05rem;
  }

  .menuItem>span {
    text-align: left;
    width: .7rem;
    padding-left: .1rem;
  }

  .tool-class {
    width: 50%;
  }

  .nowTimeBox {
    /*border-bottom: 2px solid #cce1ff;*/
    height: 48px;
    /* color: white; */
    color: #666666;
    line-height: 50px;
    margin-right: 10px;
  }

  .msgDialog {
    position: absolute;
    width: 360px;
    height: 440px;
    background: white;
    z-index: 5;
    top: 50px;
    right: 20px;
    border-radius: 5px;
    border: 1px silver solid;
    z-index: 110;
  }

  .msgDialog>p {
    padding-right: 20px;
    line-height: 40px;
    text-align: right;
    border-bottom: 1px silver solid;
    color: #0092DC;
  }

  /* 修改默认列表样式 */

  .msgDialog>>>ul.list-body {
    border-radius: 0;
  }

  .msgDialog>>>ul.list-body>li {
    padding: 0;
    border-bottom: none;
    background: none;
    cursor: default;
  }

  .msgOperate {
    overflow: hidden;
    padding: 0 24px;
    border-bottom: solid 1px #CCCCCC;
  }

  .msgOperate>button {
    height: 20px;
    box-sizing: border-box;
    margin: 8px 12px;
    color: #0F87DB;
    padding: 0 8px;
    background: #FFFFFF;
    outline: none;
    border: solid 1px #FFFFFF;
    border-radius: 10px;
    cursor: pointer;
  }

  .msgOperate>.isFilter {
    border-color: #0F87DB;

  }

  .isFilter {
    color: #0F87DB;
    background: none;
  }

  .msgOperate>span {
    float: right;
    line-height: 36px;
  }

  .filterDialog {
    position: absolute;
    height: 300px;
    width: 250px;
    background: white;
    top: 50px;
    z-index: 100;
  }

  .unitName {
    max-width: 140px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .existMsg {
    position: absolute;
    left: 5px;
    top: -5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: red;
    color: #FFFFFF;
    font-size: .12rem;
    text-align: center;
    line-height: 20px;
    transform: scale(0.6);
  }

  .unreadMsgInfo {
    padding: 10px 24px 0 24px;
  }

  .unreadHead {
    margin-bottom: 6px;
    overflow: hidden;
  }

  .msgTypeName {
    float: left;
    background: #0582DA;
    line-height: 18px;
    padding: 0 8px;
    border-radius: 8px;
    font-size: .12rem;
    color: #FFFFFF;
  }

  .msgMarkBtn {
    float: right;
    height: 18px;
    box-sizing: border-box;
    border: solid 1px #0F87DB;
    border-radius: 8px;
    font-size: .12rem;
    padding: 0 8px;
    line-height: 16px;
    color: #0F87DB;
    background: #FFFFFF;
    cursor: pointer;
  }

  .msgTimeText {
    float: right;
    line-height: 18px;
    font-size: .12rem;
    color: #0F87DB;
  }

  .msgIntro {
    font-size: .12rem;
    text-indent: 2em;
    padding-bottom: 10px;
    border-bottom: solid 1px #CCCCCC;
    white-space: normal;
  }

  .unReadMsg {
    background-color: #E3EBF1;
  }
</style>